import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  Button,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Alert
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from '@mui/icons-material/Delete';
import {
  getAllNotifications,
  deleteAllTeamNotification,
  deleteNotification
} from "../../reducers/legalteamNotificationReducer";
import { useNavigate } from "react-router-dom";

const Notifications = () => {
  const userId = useSelector((state) => state.user.userId);
  const notifications = useSelector((state) => state.notification?.list || []);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuNotificationId, setMenuNotificationId] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    if (userId) {
      dispatch(getAllNotifications(userId));
    }
  }, [userId, dispatch]);

  const handleDeleteAll = async () => {
    // console.log(userId);
    if (!userId) return;
    dispatch(deleteAllTeamNotification(userId));
    setSnackbarMsg("All notifications deleted");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
  };

  const handleNotificationClick = (id, notification) => {
    navigate("/legalteamnotificationdetails", {
      state: {
        notificationId: id,
        notifications: notification,
      },
    });
  };

  const handleMenuOpen = (event, id) => {
    setMenuAnchor(event.currentTarget);
    setMenuNotificationId(id);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setMenuNotificationId(null);
  };

  const handleDeleteNotification = async () => {
    // console.log(menuNotificationId);
    if (!menuNotificationId) return;
    dispatch(deleteNotification(menuNotificationId));
    setSnackbarMsg("Notification deleted");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
    handleMenuClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (!notifications || notifications.length === 0) {
    return (
      <Box p={3}>
        <Typography variant="h6">No notifications found.</Typography>
      </Box>
    );
  }

  return (
    <Card sx={{ maxWidth: 600, margin: "2rem auto", padding: 2 }}>
      {/* Header row */}
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" gutterBottom>
          Notifications
        </Typography>
        <Button variant="outlined" color="error" onClick={handleDeleteAll}>
          Delete All
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* Notifications list */}
      {notifications.map((notification) => (
        <Box
          key={notification.id}
          mb={2}
          p={2}
          bgcolor={notification.status === "Unread" ? "lightblue" : "#fff"}
          borderRadius={2}
          boxShadow={1}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          onClick={() => handleNotificationClick(notification.id, notification)}
        >
          <Box>
            <Typography variant="h6">{notification.title}</Typography>
            <Typography variant="body1" mt={1}>
              {notification.comments || "No additional details provided."}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Date: {new Date(notification.created_at).toLocaleString()}
            </Typography>
          </Box>

          <Box>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleMenuOpen(e, notification.id);
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        </Box>
      ))}

      {/* Menu for delete option */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleDeleteNotification}>
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
          Delete
        </MenuItem>
      </Menu>

      {/* Snackbar for success messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbarSeverity} onClose={handleSnackbarClose} sx={{ width: "100%" }}>
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default Notifications;
